// Cycle time utilities
// - Parsing helper reused across OEE services

/**
 * Parse cycle time string to minutes.
 * Supports formats: "HH:MM:SS[.fff]" and ISO 8601 duration "PTnHnMnS".
 * Returns null when invalid or non-positive.
 */
export function parseCycleTimeToMinutes(ct?: string | null): number | null {
    if (!ct) return null;
    const s = String(ct).trim();
    // ISO 8601: PnDTnHnMnS (we support only the time portion)
    if (/^P/i.test(s)) {
        const m = /P(?:\d+D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:[.,]\d+)?)S)?/i.exec(s);
        if (!m) return null;
        const hh = Number(m[1] || 0);
        const mm = Number(m[2] || 0);
        const ss = Number((m[3] || '0').replace(',', '.'));
        const totalMin = (hh * 3600 + mm * 60 + ss) / 60;
        return totalMin > 0 ? totalMin : null;
    }
    // HH:MM:SS[.fff]
    const m = /^(\d{1,2}):(\d{2}):(\d{2})(?:[.,](\d+))?$/.exec(s);
    if (!m) return null;
    const hh = Number(m[1]);
    const mm = Number(m[2]);
    const ss = Number(m[3]) + Number(m[4] ? '0.' + m[4] : 0);
    const totalMin = (hh * 3600 + mm * 60 + ss) / 60;
    return totalMin > 0 ? totalMin : null;
}


